import * as actions from '../actions';
export const getList = (listName, org) => {
    return (dispatch, getState, {
        getFirebase,
        getFirestore
    }) => {
        dispatch({
            type: actions.GET_LIST_START
        });
        const firestore = getFirestore();

        let f = firestore.collection(listName);
        if (org) f = f.where('organization.title', '==', org);

        f.get().then((querySnapshot) => {
            const data = querySnapshot.docs.map(doc => ({
                ...doc.data(),
                id: doc.id
            }));
            dispatch({
                type: actions.GET_LIST_SUCCESS,
                payload: data
            });
        }).catch((err) => {
            dispatch({
                type: actions.GET_LIST_ERROR,
                payload: err
            })
        })
    }
}